import {Pipe} from '@angular/core';
import {DatePipe} from "@angular/common";

@Pipe({standalone: true, name: 'UnixEpochTime'})
export class UnixEpochTimePipe {
  transform(value: number): string {
    let pipe = new DatePipe('de-DE');
    // to "dd-MM-yyyy HH:mm:ss" with double month and day digits
    let date = new Date(value * 1000);
    return <string>pipe.transform(date, 'dd.MM.yyyy HH:mm:ss')
  }
}
